module.exports = __webpack_public_path__ + "static/assets/4f17daa7793850e9da90555308c27e44.svg";